import react from "react";
import { useState, useEffect, useRef } from "react";
import liff from "@line/liff";
import { applyActionCode, signInWithCustomToken } from "firebase/auth";
import { auth, auth1 } from "./firebase";
import { useAuthValue } from "./AuthContext";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./forms.css";
import { useHistory, Link, useLocation, Route } from "react-router-dom";
import axios from "axios";
import "./App.css";
import Modal from "@mui/material/Modal";
import LoadingImg1 from "./LoadingImg1";

// URLから指定したクエリのバリューを抜き出す関数
const getParameterByName = (name) => {
  const url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
const updateUser = {
  findout_userId: "",
  email_address: "",
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60vw",
  boxShadow: 24,
  p: 4,
};
const windowClose = liff.closeWindow;
/**
 * 諸々のactionを行うためのページ
 */
const Action = () => {
  const { currentUser, userInfo } = useAuthValue();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [inputError, setInputError] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [updated, setUpdated] = useState(false);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    mode: null,
    actionCode: null,
    continueUrl: null,
  });
  const search = useLocation().search;
  console.log("context", currentUser);
  console.log("userInfo", userInfo);
  useEffect(async () => {
    setIsLoading(true);

    await liff.init({ liffId: "1657790190-8YB50MzX" });
    updateUser.email_address = getParameterByName("continueUrl")
      .split("https://point-ex-9709a.web.app")[1]
      .split("/mail/")[1];
    const mode = getParameterByName("mode");
    const actionCode = getParameterByName("oobCode");
    const continueUrl = getParameterByName("continueUrl")
      .split("https://point-ex-9709a.web.app")[1]
      .split("/mail/")[0];
    if (!mode || !actionCode) {
      throw new Error("invalid url");
    }
    setState({
      mode,
      actionCode,
      continueUrl,
    });

    if (!liff.isLoggedIn()) {
      console.log("start 2. LINEに未認証の場合、ログイン画面にリダイレクト");
      liff.login({
        redirectUri: window.location.href,
      });
      return;
    }
    applyActionCode(auth, actionCode)
      .then(() => {
        console.log("start 0. EmailVerified");
        console.log("start 1. login function");
        auth1.onAuthStateChanged(async (user) => {
          console.log("Start 3. firebaseの認証情報を取得 ");
          if (user) {
            // 3.1 firebaseにログイン済みの場合、ユーザー情報を取得
            const uid = user.uid;
            const token = user.accessToken;
            console.log("3.1 firebaseログイン済み ");
            const headers = {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "",
              //Authorization: `Bearer ${token}`,
            };
            // 3.1.1 ユーザIDの取得
            const getUserInfoUrl =
              "https://asia-northeast1-findout-app-7f46a.cloudfunctions.net/user/userInfo";
            const result = await axios.post(
              getUserInfoUrl,
              { uid },
              {
                headers: headers,
              }
            );
            console.log("3.1.1 ユーザ情報取得結果");
            //コンテキスト返却値: FirebaseDocumentのユーザid
            updateUser.findout_userId = result.data.userId;
          } else {
            console.log("start 3.2 firebaseにログインしていない場合");
            // 3.2 firebaseにログインしていない場合
            // 3.2.1 LIFF APIを利用して、LINEのアクセストークンを取得
            const accessToken = liff.getAccessToken();
            //////////////////////////////////////
            //////Firebase Auth カスタム認証////////
            //////////////////////////////////////
            // 3.2.3 LINEのIDトークンをfirebase functionsに投げて、firebaseのカスタム認証用トークンを取得
            const headers = {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "",
            };
            const getCustomTokenUrl =
              "https://asia-northeast1-findout-app-7f46a.cloudfunctions.net/findoutAuth/getCustomTokenByLineAccessToken";
            const result = await axios.post(
              getCustomTokenUrl,
              { accessToken },
              { headers: headers }
            );
            const customTokenJson = JSON.parse(JSON.stringify(result.data));

            // const result = await login({ accessToken });
            //   // 3.2.4 firebaseの認証用トークンを利用してカスタム認証
            const res = await signInWithCustomToken(
              auth1,
              customTokenJson.customToken
            );
            if (res.error) {
            } else {
              console.log("カスタム認証結果");
              user = res.user;
            }
            const token1 = res.user.accessToken;
            /////////////////////////////////////////////////////
            //ユーザ作成処理（lineUserId,LINE表示名,language,email)//
            /////////////////////////////////////////////////////
            const permissionStatus = await liff.permission.query("profile");
            if (permissionStatus.state === "prompt") {
              await liff.permission.requestAll();
            }
            const lineUserIdToken = liff.getDecodedIDToken();
            const lineUserName = lineUserIdToken.name;
            const lineUserPictureUrl = lineUserIdToken.picture;
            const lineUserLanguage = liff.getLanguage();
            //コンテキスト返却値: ユーザ言語設定

            const addUserDate = new Date();

            //初期ユーザプロフィール定義
            const userProfile = {
              userName: lineUserIdToken.name,
              birthDay: addUserDate.toLocaleDateString("ja-JP"),
              gender: "",
              favorite: "",
              country: "",
              stateProvice: "",
              city: "",
              address1: "",
              address2: "",
              zip: "",
              countryCode: "",
              tel: "",
              timeZone: "",
              status: 1,
              email: "",
              firebaseUid: lineUserIdToken.sub,
              language: lineUserLanguage.slice(0.2),
              lineUserId: lineUserIdToken.sub,
              mediaPath: [lineUserPictureUrl],
            };

            const userProfileJson = JSON.stringify(userProfile);
            const headers1 = {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "",
              //Authorization: `Bearer ${token1}`,
            };

            const addUserUrl =
              "https://asia-northeast1-findout-app-7f46a.cloudfunctions.net/user/add";
            const addUserResult = await axios.post(
              addUserUrl,
              userProfileJson,
              {
                headers: headers1,
              }
            );
            if (addUserResult.error) {
            } else {
              console.log("ユーザ作成成功");
              //adduserResultJsonのitemIdがユーザプロフィールのドキュメントID
              const addUserResultJson = JSON.parse(
                JSON.stringify(addUserResult.data)
              );
              updateUser.findout_userId = addUserResultJson.itemId;
            }
          }
          const headers = {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "",
            //Authorization: `Bearer ${token}`,
          };

          axios.post(
            "https://us-central1-point-ex-9709a.cloudfunctions.net/pointex/update-user2",
            updateUser,
            { headers: headers }
          );
          setIsLoading(false);
        });
      })
      .catch((err) => {
        alert("既に連携済みです");
      });
  }, []);

  return (
    <Grid>
      {isLoading ? (
        <Paper sx={{ ...modalStyle }}>
          <LoadingImg1 />
        </Paper>
      ) : (
        <Grid>
          <Grid>
            <Grid container component="main" sx={{ height: "100vh" }}>
              <CssBaseline />
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                component={Paper}
                elevation={6}
                square
                container
                direction="column"
                alignItems="center"
              >
                <Grid
                  sx={{
                    width: "50%",
                    my: 8,
                    mx: 4,
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    component="h1"
                    variant="h5"
                    color="primary"
                    align="center"
                  >
                    ユーザー連携が完了しました
                  </Typography>

                  <Grid container direction="column" alignItems="center">
                    <Route
                      path="/action"
                      component={() => {
                        setTimeout(() => {
                          history.push("/history");
                        }, 5000);
                        return null;
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default Action;
